"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ThingLink = require("./ThingLink");

var _ThingLink2 = _interopRequireDefault(_ThingLink);

var _ThingComment = require("./ThingComment");

var _ThingComment2 = _interopRequireDefault(_ThingComment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Thing = function Thing(_ref) {
  var _ref$ThingLink = _ref.ThingLink,
      ThingLink = _ref$ThingLink === undefined ? _ThingLink2.default : _ref$ThingLink,
      _ref$ThingComment = _ref.ThingComment,
      ThingComment = _ref$ThingComment === undefined ? _ThingComment2.default : _ref$ThingComment,
      kind = _ref.kind,
      data = _ref.data,
      rank = _ref.rank,
      expanded = _ref.expanded,
      props = _objectWithoutProperties(_ref, ["ThingLink", "ThingComment", "kind", "data", "rank", "expanded"]);

  var Component = { t3: ThingLink, t1: ThingComment }[kind];
  return Component ? _react2.default.createElement(Component, _extends({ expanded: expanded }, _extends({}, props, data, { rank: rank }))) : null;
};

exports.default = Thing;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/Thing.js
// module id = 194
// module chunks = 0